// Handles clicks on any link pointing to #your-privacy-choices (e.g. a
// "Your Privacy Choices" / "Do Not Sell or Share My Personal Information"
// link in the footer navigation menu). Opts the visitor out of sale/sharing
// of personal information via Shopify's native Customer Privacy API, which
// in turn drives Google Consent Mode (ad_storage/ad_user_data/
// ad_personalization) through Shopify's consent-tracking-api.js and
// Enhanced Conversions hashed-data sends.
(function () {
  function optOut() {
    window.Shopify.customerPrivacy.setTrackingConsent({ sale_of_data: false }, function () {
      window.alert(
        'You have been opted out of the sale/sharing of your personal information for advertising purposes.'
      );
    });
  }

  function handleClick(event) {
    var link = event.target.closest('a[href="#your-privacy-choices"]');
    if (!link) return;
    event.preventDefault();

    if (window.Shopify && window.Shopify.customerPrivacy) {
      optOut();
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) optOut();
      }
    );
  }

  document.addEventListener('click', handleClick);
})();
